module.exports = __webpack_public_path__ + "media/KikiAC.f7edf65e.mp3";